module.exports = __webpack_public_path__ + "img/content4.93fd9d1a.png";